let Container = window.Quill.import('blots/container')
let Scroll = window.Quill.import('blots/scroll')
let Block = window.Quill.import('blots/block')
let Parchment = window.Quill.import('parchment')
let BlockEmbed = window.Quill.import('blots/block/embed')
let quill = null

export function setEditor (editor) {
  quill = editor
}
//
//
// CONTAINER TAG
//

class ContainBlot extends Container {
  static create (value) {
    let tagName = 'contain'
    let node = super.create(tagName)
    return node
  }

  insertBefore (blot, ref) {
    if (blot.statics.blotName === this.statics.blotName) {
      /* console.log('############################ Not sure this is clean:')
      console.log(blot)
      console.log(blot.children.head) */
      super.insertBefore(blot.children.head, ref)
    } else {
      super.insertBefore(blot, ref)
    }
  }

  static formats (domNode) {
    return domNode.tagName
  }

  formats () {
    // We don't inherit from FormatBlot
    return { [this.statics.blotName]: this.statics.formats(this.domNode) }
  }

  replace (target) {
    if (target.statics.blotName !== this.statics.blotName) {
      let item = Parchment.create(this.statics.defaultChild)
      target.moveChildren(item)
      this.appendChild(item)
    }
    if (target.parent == null) return
    super.replace(target)
  }
}

ContainBlot.blotName = 'contain'
ContainBlot.tagName = 'contain'
ContainBlot.scope = Parchment.Scope.BLOCK_BLOT
ContainBlot.defaultChild = 'block'
ContainBlot.allowedChildren = [Block, BlockEmbed, Container]
window.Quill.register(ContainBlot)

//
//
// CONTAINER TR
//

class TableRow extends Container {
  static create (value) {
    let tagName = 'tr'
    let node = super.create(tagName)
    node.setAttribute('rowId', value)
    return node
  }

  optimize () {
    super.optimize()
    let next = this.next
    if (next != null && next.prev === this &&
        next.statics.blotName === this.statics.blotName &&
        next.domNode.tagName === this.domNode.tagName &&
        next.domNode.getAttribute('rowId') === this.domNode.getAttribute('rowId')) {
      next.moveChildren(this)
      next.remove()
    }
  }

}

TableRow.blotName = 'tr'
TableRow.tagName = 'tr'
TableRow.scope = Parchment.Scope.BLOCK_BLOT
TableRow.defaultChild = 'td'
window.Quill.register(TableRow)

//
//
// CONTAINER TABLE
//

class TableTrick {
  static randomId () {
    return Math.random().toString(36).slice(2)
  }
  static findTd (what) {
    let leaf = quill.getLeaf(quill.getSelection()['index'])
    let blot = leaf[0]
    for (;blot != null && blot.statics.blotName !== what;) {
      blot = blot.parent
    }
    return blot // return TD or NULL
  }
  static appendCol () {
    let td = TableTrick.findTd('td')
    if (td) {
      let table = td.parent.parent
      let tableId = table.domNode.getAttribute('tableId')
      td.parent.parent.children.forEach(function (tr) {
        let rowId = tr.domNode.getAttribute('rowId')
        let cellId = TableTrick.randomId()
        let td = Parchment.create('td', tableId + '|' + rowId + '|' + cellId)
        tr.appendChild(td)
      })
    }
  }
  static appendRow () {
    let td = TableTrick.findTd('td')
    if (td) {
      let colCount = td.parent.children.length
      let table = td.parent.parent
      let newRow = td.parent.clone()
      let tableId = table.domNode.getAttribute('tableId')
      let rowId = TableTrick.randomId()
      newRow.domNode.setAttribute('rowId', rowId)
      for (var i = colCount - 1; i >= 0; i--) {
        let cellId = TableTrick.randomId()
        let td = Parchment.create('td', tableId + '|' + rowId + '|' + cellId)
        newRow.appendChild(td)
      }
      table.appendChild(newRow)
      // console.log(newRow)
    }
  }
  static removeRow () {
    let td = TableTrick.findTd('td')
    if (td) {
      let tr = td.parent
      tr.remove()
    }
  }
  static removeCol () {
    let td = TableTrick.findTd('td')
    if (td) {
      let table = td.parent.parent
      let cellId = td.domNode.getAttribute('cell_id')
      let colIndex = 1

      // Count colIndex
      td.parent.children.forEach(function loop (_td) {
        if (_td.domNode.getAttribute('cell_id') === cellId) {
          loop.stop = true
          return
        }
        // ~~ hack: Ecmascript doesn't support `break` :-/ ~~
        if (!loop.stop) {
          colIndex += 1
        }
      })

      // Remove all TDs with the colIndex
      table.children.forEach(function (tr) {
        let _td = tr.children.find(colIndex)[0]
        if (_td) {
          _td.remove()
        }
      })
    }
  }
  static removeTable () {
    let td = TableTrick.findTd('td')
    if (td) {
      let table = td.parent.parent
      table.remove()
    }
  }
  static cellBackground (color) {
    let td = TableTrick.findTd('td')
    if (td) {
      let style = 'background:' + color
      td.format('style', color ? style : false)
    }
  }

}

class Table extends Container {
  static create (value) {
    // special adding commands - belongs somewhere else out of constructor
    if (value === 'append-row') {
      let blot = TableTrick.appendRow()
      return blot
    } else if (value === 'append-col') {
      let blot = TableTrick.appendCol()
      return blot
    } else if (value.includes('newtable_')) {
      let node = null
      let sizes = value.split('_')
      let rowCount = Number.parseInt(sizes[1])
      let colCount = Number.parseInt(sizes[2])
      let tableId = TableTrick.randomId()
      let table = Parchment.create('table', tableId)
      for (var ri = 0; ri < rowCount; ri++) {
        let rowId = TableTrick.randomId()
        let tr = Parchment.create('tr', rowId)
        table.appendChild(tr)
        for (var ci = 0; ci < colCount; ci++) {
          let cellId = TableTrick.randomId()
          value = tableId + '|' + rowId + '|' + cellId
          let td = Parchment.create('td', value)
          tr.appendChild(td)
          let p = Parchment.create('block')
          td.appendChild(p)
          let br = Parchment.create('break')
          p.appendChild(br)
          node = p
        }
      }
      let leaf = quill.getLeaf(quill.getSelection()['index'])
      let blot = leaf[0]
      let topBranch = null
      for (;blot != null && !(blot instanceof Container || blot instanceof Scroll);) {
        topBranch = blot
        blot = blot.parent
      }
      blot.insertBefore(table, topBranch)
      return node
    } else {
      if (value === 'remove-row') {
        TableTrick.removeRow()
        return node
      }
      if (value === 'remove-col') {
        TableTrick.removeCol()
        return node
      }
      if (value === 'remove-table') {
        TableTrick.removeTable()
        return node
      }
      if (value === 'cell-background') {
        let bgColor = prompt('Background color?')
        TableTrick.cellBackground(bgColor)
        return node
      }
      // normal table
      let tagName = 'table'
      let node = super.create(tagName)
      node.setAttribute('tableId', value)
      return node
    }
  }

  optimize () {
    // console.log("OPTIMIZE start")
    super.optimize()
    let next = this.next
    if (next != null && next.prev === this &&
        next.statics.blotName === this.statics.blotName &&
        next.domNode.tagName === this.domNode.tagName &&
        next.domNode.getAttribute('tableId') === this.domNode.getAttribute('tableId')) {
      next.moveChildren(this)
      next.remove()
    }
    // console.log("OPTIMIZE end")
  }

}

Table.blotName = 'table'
Table.tagName = 'table'
Table.scope = Parchment.Scope.BLOCK_BLOT
Table.defaultChild = 'tr'
Table.allowedChildren = [TableRow]
window.Quill.register(Table)

//
//
// CONTAINER TD
//

class TableCell extends ContainBlot {

  static create (value) {
    // console.log(value)
    let tagName = 'td'
    let node = super.create(tagName)
    let ids = value.split('|')
    node.setAttribute('tableId', ids[0])
    node.setAttribute('rowId', ids[1])
    node.setAttribute('cellId', ids[2])
    node.setAttribute('style', ids[3] || '')
    return node
  }

  format (key, value) {
    this.domNode.setAttribute(key, value)
  }

  formats () {
    // We don't inherit from FormatBlot
    return { [this.statics.blotName]:
      this.domNode.getAttribute('tableId') + '|' +
      this.domNode.getAttribute('rowId') + '|' +
      this.domNode.getAttribute('cellId') + '|' +
      this.domNode.getAttribute('style')
    }
  }

  optimize () {
    super.optimize()

    // Add parent TR and TABLE when missing
    let parent = this.parent
    if (parent != null && parent.statics.blotName !== 'tr') {
      // we will mark td position, put in table and replace mark
      let mark = Parchment.create('block')
      this.parent.insertBefore(mark, this.next)
      let table = Parchment.create('table', this.domNode.getAttribute('tableId'))
      let tr = Parchment.create('tr', this.domNode.getAttribute('rowId'))
      table.appendChild(tr)
      tr.appendChild(this)
      table.replace(mark)
    }

    // merge same TD id
    let next = this.next
    if (next != null && next.prev === this &&
        next.statics.blotName === this.statics.blotName &&
        next.domNode.tagName === this.domNode.tagName &&
        next.domNode.getAttribute('cellId') === this.domNode.getAttribute('cellId')) {
      next.moveChildren(this)
      next.remove()
    }
  }
}

TableCell.blotName = 'td'
TableCell.tagName = 'td'
TableCell.scope = Parchment.Scope.BLOCK_BLOT
TableCell.defaultChild = 'block'
TableCell.allowedChildren = [Block, BlockEmbed, Container]
window.Quill.register(TableCell)
TableRow.allowedChildren = [TableCell]

Container.order = [
  'list', 'contain',   // Must be lower
  'td', 'tr', 'table'              // Must be higher
]

// window.Quill.debug('debug')



// WEBPACK FOOTER //
// ./src/utils/quill.table.js